(() => {
  try {
    const script = document.currentScript;
    if (!script || window.Shopify?.designMode) return;
    if (new URLSearchParams(location.search).get('igk_attrac_native') === '1') return;
    const pageType = script.dataset.pageType;
    const vendor = script.dataset.productVendor;
    if (!pageType || (pageType === 'product' && !vendor)) return;
    const inputs = document.querySelectorAll('input.aph_bars_app_embed');
    if (inputs.length !== 1) return;
    const input = inputs[0];
    const campaigns = JSON.parse(input.value);
    if (!Array.isArray(campaigns)) return;

    const offerVendors = ["Carl's Place", 'The Indoor Golf Shop'];
    const shippingVendors = [
      'Big Moss', 'Epson', 'G-TRAK', 'GolfIn', 'GOLFJOY', 'HomeCourse',
      'LG', 'NVISAGE', 'SimBooth', 'Spornia', 'SurfThing',
      'Synthetic Turf International', 'The Net Return', 'Trackman',
      'TruGolf', 'Uneekor', 'Voice Caddie', 'VTrack', 'Optoma'
    ];
    const rules = new Map([
      ['78160408_218854', { type: 'bar', page: 'index' }],
      ['18120267_919591', { type: 'bar', page: 'product', vendors: shippingVendors }],
      ['92942625_959535', { type: 'bar', page: 'product', vendors: offerVendors }],
      ['78139449_849048', { type: 'bar', page: 'product', vendors: ['BenQ'] }],
      ['50508635_720439', { type: 'popup', page: 'product', vendors: ['BenQ'] }],
      ['75123669_108222', { type: 'popup', page: 'product', vendors: ['BenQ'] }],
      ['79641701_334198', { type: 'popup', page: 'product', vendors: offerVendors }],
      ['10905245_585191', { type: 'popup', page: 'product', vendors: offerVendors }]
    ]);
    const filtered = campaigns.filter(campaign => {
      const rule = rules.get(campaign?.id);
      if (!rule || campaign.type !== rule.type) return true;
      if (rule.page !== pageType) return false;
      return !rule.vendors || rule.vendors.includes(vendor);
    });
    if (filtered.length !== campaigns.length) input.value = JSON.stringify(filtered);
    script.dataset.total = String(campaigns.length);
    script.dataset.kept = String(filtered.length);
  } catch (_) {}
})();
